export default __webpack_public_path__ + "static/media/logo.2ab33641.svg";